// extracted by mini-css-extract-plugin
module.exports = {"chartContainer":"modelPrices_chartContainer__Q_Lad","newModel":"modelPrices_newModel__C2_pz"};